module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Aquaman.3b548a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Aquaman.jpg
// module id = xbUo
// module chunks = 0